import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';
import MUIRichTextEditor from './MUIRichTextEditor';
import MuiSwitch from './MuiSwitch';
import MUIDataTable from './MUIDataTable'
import MUIDataTableHeadCell from './MUIDataTableHeadCell';
import MuiTableContainer from './MuiTableContainer';

export default {
  MuiButton,
  MuiIconButton,
  MuiOutlinedInput,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTypography,
  MUIRichTextEditor,
  MuiSwitch,
  MUIDataTable,
  MUIDataTableHeadCell,
  MuiTableContainer
};
